/**
 * @title ModalImage-lightbox.js: Sub-module of Product feature
 * @description This module encapsulates all of the
 * functionality related to the ModalImage-lightbox view component of product display.
 * @dependency  modalZoom-viewer.js
 */
define([], function() {
  let ModalImageLightboxView = {
    
    /**
     * Opens Image Lightbox modal.
     */
    openImageLightBoxModal: function(event, overlayThumbClicked = false) {
      
      if ($('#zoomViewer').length) {
        
        ModalImageLightboxView.destroyLCVideo();
        
        let currentWindowPosition = $(window).scrollTop();
        let newViewerSize = ModalImageLightboxView.getViewerSize();
        let imageContainerWidth = newViewerSize > $(window).width()?'auto':newViewerSize+'px';
        let activeElement = document.activeElement;
        
        let currentView = ModalImageLightboxView.getSelectedViewId(overlayThumbClicked);
        
        let itemID = null;
        let imageURL = zoomViewer.viewerUrl;
        let rfxMediaParams = $('#productImage').attr('rfxmedia');
        //Check if the product has swatches for color change 
        let swatch =RICHFX.settings.sCurrentSwatch;
        if (swatch != 'undefined' && swatch != "" && swatch!= null && swatch != undefined) {
          swatch =  '&swatchId='+ swatch;
        } else {
          swatch ="";
        }
        rfxMediaParams.split("&").forEach(function(part) {
          let item = part.split("=");
          if(item[0] === 'itemid') {
            itemID = item[1];
          }
        });

        _LCdiv_ID = 'contentWrapper';
        var modalHTML ='<div id="openModal" class="modalDialog">'+
          '<div id="modalContainer">'+
          '<button id="viewsPrevArrow" class="showForDesktop" style="display:none !important">'+
            '<span class="sr-only">'+messages.PREVIOUS_IMAGE+'</span>'+
          '</button>'+
            '<div id="imageHolder" style="width: '+imageContainerWidth+'; top 0px; margin: 0px auto;">'+
              '<img id="modalImage" src="'+zoomViewer.viewerUrl+newViewerSize+swatch+'&viewId='+currentView+'" rfxccgroup="itemId='+itemID+'" rfxMedia="profileId=12026540&'+itemID+swatch+'&viewId='+currentView+'">'+
            '</div>'+
            '<div id="contentWrapper" style="padding: 0 10%"></div>' +
            '<button id="viewsNextArrow" class="showForDesktop" style="display:none !important">'+
              '<span class="sr-only">'+messages.NEXT_IMAGE+'</span>'+
            '</button>'+
            
        	  '<div id="zoomInstruction">'+
	        	'<div class="modal-zoom-pan showForDesktop">'+
		    		'<img src="/wcsstore/RWDStaticAssets/img/ZoomComponent-ZoomIn.svg" alt="Zoomer" usemap="#zoomerImage">'+
		    		'<map id="zoomAndPanImage" name="zoomerImage">'+
		    			'<area id="zoomAndPanImage_magnifier_in" shape="rect" alt="'+messages.MAGNIFYING_GLASS_ZOOM_IN+'" title="" coords="11,11,20,20" href="#" target="" />'+
		    			'<area id="zoomAndPanImage_arrow_up" shape="rect" alt="'+messages.UP_CHEVRON_PAN_UP+'" title="" coords="11,0,20,10" href="#" target=""/>'+
		    			'<area id="zoomAndPanImage_arrow_right" shape="rect" alt="'+messages.RIGHT_CHEVRON_PAN_RIGHT+'" title="" coords="21,11,30,20" href="#" target="" />'+
		    			'<area id="zoomAndPanImage_arrow_down" shape="rect" alt="'+messages.DOWN_CHEVRON_PAN_DOWN+'" title="" coords="11,21,20,30" href="#" target="" />'+
		    			'<area id="zoomAndPanImage_arrow_left" shape="rect" alt="'+messages.LEFT_CHEVRON_PAN_LEFT+'" title="" coords="0,11,10,20" href="#" target="" />'+
		    		'</map>'+
	    		'</div>'+
	    		
	            '<div class="zoom-message-wrapper zoomInstructionOverlay" style="background-color: #fff;">' +
	              '<div class="col-xl-12 showForDesktop" style="padding-top: 5px; background-color: #fff; opacity: 0.8">'+messages.RWD_CLICK_ZOOM+'</div>'+
	              '<div class="col-lg-12 showForMobile" style="padding-top: 5px;">'+messages.RWD_TAP_ZOOM+'</div>'+    
	            '</div>'+
              '</div>'+

          '</div>'+
          '<div id="currentSlide" class="row"></div>'+
          '<hr>'+
          '<div id="modalThumbnails" class="row" style="margin: 0px auto;">'+
            '<div class="col-xs-12">'  +
              '<div id="modalViews"></div>'+
            '</div>'+
          '</div>'+
          '<div id="modalSwatches" style="display:none;"></div>'+
        '</div>';
        $('div#videoViewer-popup').css("width",newViewerSize);
        window.eventBus.publish('videoUpdate',{ItemNumbers: _LCdim5,type:"basic",aspectRatio:"1:1",bfFolderType:"pdp"});
        $('#videoViewer-popup').hide();

        COSTCO.dialog.createExtDialogBox({
          body: modalHTML,
          hideFooter: true,
          dialogclasses: 'medium image-lightbox-modal image-lightbox-modal-v2',
          onshow: function() {
            console.log('PDP Image Modal: onshow');

            let $image = $('#modalImage');
            $image.on('load', function () {
              console.log('PDP Image Modal: Enter load');
              console.log('PDP Image Modal: initialized = ' + COSTCO.ModalZoomViewer.initialized);

              if (COSTCO.ModalZoomViewer.initialized == false) {
                console.log('PDP Image Modal: initializing richfx');
                COSTCO.ModalZoomViewer.initialized = true;
                console.log('PDP Image Modal: richfx initialized');

                RICHFX.load.reset();
                RICHFX.settings.init('PZ' + newViewerSize + 'Multi');
                console.log('PDP Image Modal: richfx initialization started, now wait for richmedia.state.loaded event');
              }

              console.log('PDP Image Modal: Exit load');
            });

            /*
             *  This is required for safari browser, safari will not trigger regular 'load' event if image is served from cache (ususally second open of modal)
             */
            if ($image[0].complete) { 
              console.log('PDP Image Modal: Manually triggered event for image loaded');
              $image.load();
            }

            $(window).on('scroll', {position: currentWindowPosition}, COSTCO.ModalZoomViewer.lockWindowScrolling);
            $(window).on('error', COSTCO.ModalZoomViewer.reloadThumbnailsOnScriptError);
            $('body').addClass('image-lightbox-modal-open');
            $("#costcoModal").addClass('lightbox-modal-v2');
           
          },
          onclose: function() {          
            $(window).off('scroll',COSTCO.ModalZoomViewer.lockWindowScrolling);
            $(window).off('error', COSTCO.ModalZoomViewer.reloadThumbnailsOnScriptError);
            
            $('.RICHFXViewerContainer').show();

            if (activeElement != undefined) {
                activeElement.focus();
            }
            
            ModalImageLightboxView.resetLiveclicker();

            $('body').removeClass('image-lightbox-modal-open');
            $("#costcoModal").removeClass('lightbox-modal-v2');

            COSTCO.ModalZoomViewer.initialized = false;
            console.log('PDP Image Modal: Closing modal, initialized = ' + COSTCO.ModalZoomViewer.initialized);
            window.eventBus.publish('videoUpdate',{ItemNumbers: _LCdim5,type:"basic",aspectRatio:"1:1",bfFolderType:"pdp"});
            $(document).trigger('costco.pdp.modal.closed');
          }
        });

        //This line needs to be removed when the WebCollage changes the scripts
        $('.wc-content-package-mosaic-board').attr('style','z-index:20010 !important');
      }
    },

    /**
     * Removes element with ID lcVideo, if found on the page / modal. This is necessary if having 2 instances of video (inline and modal)
     */
     destroyLCVideo: function() {
      if ($('#lcVideo').length == 1) {
        console.log('PDP Image Modal: Destroying #lcVideo');
        $('#lcVideo').remove();
      }
     },
     
     /**
      * Resets Liveclicker video player.
      */
     resetLiveclicker: function() {
       ModalImageLightboxView.destroyLCVideo();

       _LCdiv_ID = 'productImageContainer'; // This value is required for inline lightbox viewer.

       if (typeof liveclicker != 'undefined') {
         liveclicker = {
           lcCheckReadyObject: function() {},
         }
       }
     },

    /**
     * Gets the currently selected view id
     */
    getSelectedViewId: function(clickedOnOverlayImages) {
      if (clickedOnOverlayImages) {
        return ModalImageLightboxView.getIdOfFirstOverlayImage();
      } else {
        let tmpArray = $('.RICHFXColorChangeViewSelected').length > 0 ? $('.RICHFXColorChangeViewSelected').attr('id').split('_') : $('.RICHFXColorChangeViewSelected');
        if (tmpArray && tmpArray.length > 0) {
          return tmpArray[tmpArray.length - 1];
        } else {
          return "1"; 
        }
      }
    }, 
    
	getIdOfFirstOverlayImage: function() {
	  let idValue = $('.overlay').parent().find('img').attr('id');
	  let tmpArray = idValue.length > 0 ? idValue.split('_') : idValue;
        if (tmpArray && tmpArray.length > 0) {
      	  firstOverlayImageId = tmpArray[tmpArray.length - 1];
      	} else {
      	  firstOverlayImageId = "1";
      	}
        return firstOverlayImageId;
	},	
    
    getViewerSize: function() {
      let width = $(window).width();
      let height = $(window).height();
      if (width > 1000 && height > 870) return 680;
      if (width > 764 && height > 729) return 470;
      if (width > 750 && height > 600) return 352;
      return 344;
    },
    
    /**
     * Saved id of focused element  on lightbox open
     */
    saveFocusedElement: function(event) {
      if (typeof event !== 'undefined') {
        if(event.target.id) {
             $('<input>').attr({
              type: 'hidden',
              id: 'lastFocusedElement',
              value: event.target.id
            }).appendTo('body');
        } else {
           //keyboard event was triggered
          img = $(event.target).find('img').attr('id');
          elementId = $(event.target).find('img').attr('id');
          if(elementId) {
               $('<input>').attr({
                type: 'hidden',
                id: 'lastFocusedElement',
                value: elementId
                }).appendTo('body');
          }
        }
      }
    },
  }
  
  if (typeof window.COSTCO == 'undefined') {
    window.COSTCO = new Object();
  }
  
  window.COSTCO.ModalImageLightboxView = ModalImageLightboxView;
  
  return ModalImageLightboxView;
});



// WEBPACK FOOTER //
// ./js/product/modalImage-lightbox.js